export enum RouteKeys {
  List = '/permission',
}
